import { CoachOutletReceipt } from './coach-outlet-receipt'
import { MkOutletReceipt } from './mk-outlet-receipt'
import { ReceiptPrototype } from './receipt.prototype'

export class TextReceipt {

  constructor() {}

  process(text: string): MkOutletReceipt | CoachOutletReceipt | ReceiptPrototype {
    text = text.toLowerCase()
    if (text.includes('coach')) {
      return new CoachOutletReceipt(text)
    }
    if (text.includes('michael kors') || text.match(/\d{12}/)) {
      return new MkOutletReceipt(text)
    }
    return new ReceiptPrototype()
  }

}



// WEBPACK FOOTER //
// ./src/app/models/text-receipt/text-receipt.ts